import { Map } from 'immutable'
import { Updater } from 'widgets-for-react'
import { getCookie } from '../../../Shared/Frontend/utils/cookies'
import { State } from '../cms/cmsPage.widget'
import { shouldShowCookies } from './cookiebar.widget'
import { updateConsent } from './cookiebar.utils'

export type CookieAccepted = 'yes' | 'no'

export type CookieName = 'functional-cookies' | 'analytical-cookies' | 'video-cookies' | 'tracking-cookies'

export type CookieState = {
  isAccepted: CookieAccepted
  isDisabled: boolean
  isRequired: boolean
  label: string
  htmlFor: string
}

export type CookiebarState = {
  Cookies: Map<CookieName, CookieState>
  tmpCookies: Map<CookieName, CookieState>
  ExpandOptions: boolean
  CookieBarVisible: boolean
}

export const cookiebarStateZero = (props: {
  cookieNames: CookieName[]
  labels: Map<CookieName, string>
  htmlFor: Map<CookieName, string>
  readonlyCookies?: CookieName[]
  requiredCookies?: CookieName[]
}): CookiebarState => {
  let Cookies: Map<CookieName, CookieState> = Map<CookieName, CookieState>()
  let isIn = (c: CookieName, cList: CookieName[] | undefined) => {
    if (cList === undefined) return false
    return cList.find((c1) => c === c1) !== undefined
  }
  let isIn2 = (c: CookieName, cList: Map<CookieName, string>) => {
    if (cList === undefined) return ''
    if (cList.has(c)) return cList.get(c)
    return ''
  }
  props.cookieNames.forEach((cookieName) => {
    let isAccepted: CookieAccepted =
      getCookie(cookieName) === 'yes' || isIn(cookieName, props.readonlyCookies) ? 'yes' : 'no'
    if (isAccepted) updateConsent(cookieName, isAccepted == 'yes')
    Cookies = Cookies.set(cookieName, {
      isAccepted,
      isDisabled: isIn(cookieName, props.readonlyCookies),
      isRequired: isIn(cookieName, props.requiredCookies),
      label: isIn2(cookieName, props.labels) || '',
      htmlFor: isIn2(cookieName, props.htmlFor) || '',
    })
  })

  return {
    Cookies,
    tmpCookies: Cookies.toMap(),
    ExpandOptions: false,
    CookieBarVisible: shouldShowCookies(),
  }
}

export const makeEmptyCookieStateZero = () =>
  cookiebarStateZero({
    cookieNames: [],
    htmlFor: Map(),
    labels: Map(),
    readonlyCookies: [],
    requiredCookies: [],
  })

export const makeProjectCookieStateZero = () => {
  let cookiebarState = cookiebarStateZero({
    cookieNames: ['functional-cookies', 'analytical-cookies', 'video-cookies', 'tracking-cookies'],
    htmlFor: Map()
      .set('functional-cookies', 'functional-cookies')
      .set('analytical-cookies', 'analytical-cookies')
      .set('video-cookies', 'video-cookies')
      .set('tracking-cookies', 'tracking-cookies') as Map<CookieName, string>,
    labels: Map()
      .set('functional-cookies', 'cookies:cookiebarFunctional cookies:cookiebarFunctionalCookies')
      .set('analytical-cookies', 'cookies:cookiebarAnalytical cookies:cookiebarAnalyticalCookies')
      .set('video-cookies', 'cookies:cookiebarVideos cookies:cookiebarVideosCookies')
      .set('tracking-cookies', 'cookies:cookiebarTracking cookies:cookiebarTrackingCookies') as Map<CookieName, string>,
    readonlyCookies: ['functional-cookies', 'analytical-cookies'],
    requiredCookies: ['functional-cookies', 'analytical-cookies'],
  })
  return cookiebarState
}

export type CookiePlaceholderStyle = Partial<{
  cookiesClassName: string
  cookiesInnerClassName: string
  cookiesTextClassName: string
  cookiesClickableClassName: string
  cookiesClickableLabelClassName: string
  cookiesClickableIconClassName: string
  iconId: string
}>

export type CookiebarStyle = Partial<{
  cookiebarClassName: string
  cookiebarOuterClassName: string
  cookiebarInnerClassName: string
  cookiebarTextClassName: string
  cookiebarTitleClassName: string
  cookiebarIntroClassName: string
  cookiebarFooterClassName: string
  cookiebarClickableWrapperClassName: string
  cookiebarClickablePrimaryClassName: string
  cookiebarClickableSecondaryClassName: string
  cookiebarClickableLabelClassName: string
  cookiebarClickableIconClassName: string
  iconId: string
  // Settings Button
  cookiebarSettingsClassName: string
  cookiebarSettingsLabelClassName: string
  cookiebarSettingsIconClassName: string
  settingsIconId: string
  // Settings
  cookiebarFormClassName: string
  cookiebarFormListClassName: string
  cookiebarFormItemClassName: string
  cookiebarFormFooterClassName: string
  cookiebarSubmitClassName: string
  cookiebarSubmitLabelClassName: string
  cookiebarSubmitIconClassName: string
  submitIconId: string
}>

export const cookieBarStateUpdaters = {
  updateCookiebarState:
    (u: Updater<CookiebarState>): Updater<State> =>
    (s) => {
      let s1 = { ...s, cookiebarState: u(s.cookiebarState) }
      return s1
    },
}
